import React from "react";
import { useNavigate } from "react-router-dom";
import { SectionHeading } from "../SectionHeading";
import { PricingCard } from "../cards";
import { motion } from "framer-motion";

export function PricingSection({
    title,
    description,
    badge,
    pricing,
    ...rest
}) {
    const navigate = useNavigate();
    const [tenure, setTenure] = React.useState("yearly");

    const handleMulaiSekarang = (price, index) => {
        const planIds = ["6bulan", "12bulan"];
        const planId = planIds[index] || "6bulan";
        sessionStorage.setItem("selectedPlan", planId);
        navigate("/payment");
    };

    return (
        <section className="bg-white py-24" {...rest}>
            <div className="container max-w-6xl px-4 sm:px-6 lg:px-8 mx-auto">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                >
                    <SectionHeading
                        align="center"
                        title={title}
                        description={description}
                        badge={badge}
                    />
                </motion.div>

                <div className="flex flex-wrap gap-6 justify-center items-start mt-16 mx-auto">
                    {pricing
                        .filter(
                            (p) =>
                                p.value?.monthly !== 0 && p.value?.yearly !== 0,
                        )
                        .map((price, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 40, scale: 0.97 }}
                                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{
                                    duration: 0.5,
                                    delay: index * 0.15,
                                    ease: [0.25, 0.46, 0.45, 0.94],
                                }}
                            >
                                <PricingCard
                                    {...price}
                                    tenure={tenure}
                                    onMulaiSekarang={() =>
                                        handleMulaiSekarang(price, index)
                                    }
                                />
                            </motion.div>
                        ))}
                </div>
            </div>
        </section>
    );
}
